import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import selectn from "selectn";
import qs from "qs";

import TopStories from "dashboard/components/TopStories";
import {
  getStoriesStream,
  loadRevision,
  loadLatest,
} from "actions/storiesStream";
import { getLocalItem } from "utils/localdb";

class StoryPermalink extends React.Component {
  componentDidMount() {
    this.loadStream(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.loadStream(nextProps);
    }
  }

  loadStream(props) {
    const params = qs.parse(props.location.search.slice(1));
    const adminToken = getLocalItem("adminToken");
    if (params.preview && adminToken) {
      if (params.revision) {
        return this.props.loadRevision(props.match.params.id, params.revision, adminToken);
      } else {
        return this.props.loadLatest(props.match.params.id, adminToken);
      }
    }

    return this.props.getStoriesStream({ story: props.match.params.id });
  }

  render() {
    const story = this.props.stream.results[0];
    const ogImage = selectn("social_image.crops.16x9.url", story) || selectn("primary_image.crops.16x9.url", story);

    return (
      <div>
        {story && (
          <Helmet>
            <title>{story.headline} - Axios</title>
            <meta property="og:url" content={story.permalink} />
            <meta property="og:title" content={story.og_headline || story.headline} />
            {story.og_description && <meta property="og:description" content={story.og_description} />}
            {story.og_description && <meta property="description" content={story.og_description} />}
            {ogImage && <meta property="og:image" content={ogImage} />}
          </Helmet>
        )}
        <TopStories />
      </div>
    );
  }
}

StoryPermalink.propTypes = {
  stream: PropTypes.shape({
    results: PropTypes.arrayOf(
      PropTypes.shape({
        headline: PropTypes.string.isRequired,
        permalink: PropTypes.string.isRequired,
        og_description: PropTypes.string,
        og_image: PropTypes.object,
        primary_image: PropTypes.object,
      })
    ).isRequired,
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }),
  getStoriesStream: PropTypes.func.isRequired,
  loadLatest: PropTypes.func,
  loadRevision: PropTypes.func,
};

const mapStateToProps = (state) => ({
  stream: state.storiesStream,
});

const mapDispatchToProps = {
  getStoriesStream,
  loadLatest,
  loadRevision,
};

export default connect(mapStateToProps, mapDispatchToProps)(StoryPermalink);



// WEBPACK FOOTER //
// ./src/dashboard/containers/StoryPermalink/StoryPermalink.js